import { Activity, Client } from '../../../pure-js/types/GrooverTypes'
import { PublicActivitiesQueryParams } from '../../../pure-js/libs/PublicActivitiesHelper'

export type PublicActivitiesInitialData = {
  client: Client
  activities: Activity[]
  queryParams: PublicActivitiesQueryParams
}

const INITIAL_SCRIPT_ID = '__PUBLIC_ACTIVITIES_INITIAL__'

declare global {
  interface Window {
    __PUBLIC_ACTIVITIES_INITIAL__?: PublicActivitiesInitialData
  }
}

export const readPublicActivitiesInitialData = (): PublicActivitiesInitialData | null => {
  if (typeof window === 'undefined') return null

  const fromWindow = window.__PUBLIC_ACTIVITIES_INITIAL__
  if (fromWindow?.client && Array.isArray(fromWindow.activities)) {
    delete window.__PUBLIC_ACTIVITIES_INITIAL__
    return fromWindow
  }

  const scriptEl = document.getElementById(INITIAL_SCRIPT_ID)
  if (!scriptEl?.textContent) return null

  try {
    const parsed = JSON.parse(scriptEl.textContent) as PublicActivitiesInitialData
    if (!parsed?.client || !Array.isArray(parsed.activities)) return null
    scriptEl.remove()
    return parsed
  } catch {
    return null
  }
}
